import type { EditorAPI } from '#packages/editorAPI';

const getPagesContainerAbsLayout = (editorAPI: EditorAPI) => {
  const pagesContainer = editorAPI.dsRead.siteSegments.getPagesContainer();
  return editorAPI.components.layout.getRelativeToScreen(pagesContainer);
};

export { getPagesContainerAbsLayout };
